<div class="content">
  <h1>{{ "my.title" | translate }}</h1>
  @if (!loading && !errorText && myEvents.length > 0) {
  <div class="row overview-items">
    @for (event of myEvents; track event; let i = $index) {
    <!-- Google Ads -->
    @if (displayAds && i % 5 === 0 && i > 0) {
    <div
      class="col-xs-12 col-sm-8 col-md-6 col-lg-4 col-xl-3 col-xxl-2"
      style="align-content: center; max-height: 350px !important"
    >
      <ins
        class="adsbygoogle"
        style="display: block"
        data-ad-client="ca-pub-1807328328271021"
        data-ad-slot="1071743474"
        data-ad-format="rectangle, horizontal"
        data-full-width-responsive="true"
      ></ins>
    </div>
    }
    <!-- Streapps -->
    <div
      class="col-xs-12 col-sm-8 col-md-6 col-lg-4 col-xl-3 col-xxl-2 overview-item-alternate"
    >
      <overview-card-alternate-version
        [event]="event"
      ></overview-card-alternate-version>
    </div>
    }
    <div class="noMoreEvents">
      <span class="noMoreEventsLabel">{{
        "page.noMoreEvents" | translate
      }}</span>
    </div>
  </div>
  } @if (!loading && !errorText && myEvents.length === 0) {
  <div class="errorText">
    {{ "page.noVideosPersonal" | translate }}
  </div>
  } @if (loading) {
  <div class="loading">
    <mat-progress-spinner
      class="loading-spinner"
      [diameter]="250"
      mode="indeterminate"
      color="primary"
    >
    </mat-progress-spinner>
    <div class="loading-text"><h1>Starten...</h1></div>
  </div>
  }
</div>
